exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ui.input.search input {\n  padding-right: 32px !important;\n  padding-left: 32px !important; }\n\n.ui.input.search .icon {\n  cursor: pointer;\n  position: absolute; }\n\n.ui.input.search .search-icon {\n  right: auto;\n  left: 0;\n  margin: 7px 6px;\n  height: 19px;\n  width: 19px;\n  opacity: 0.7; }\n\n.ui.input.search .close {\n  left: auto;\n  right: 0;\n  margin: 11px 9px;\n  height: 13px;\n  width: 13px;\n  opacity: 0.5; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Common/Form/searchInput.scss
// module id = 1469
// module chunks = 1